import { RootState } from "../../../../store/types";
import { AppDispatch } from "../../../../store";
import { connect } from "react-redux";
import ProcessPathVolumeRow from "./ProcessPathVolumeRow";
import { updateProcessPathOverride } from "../../../../store/slices/volumesAndWipSlice";
import { ProcessPathOverride } from "../../../../store/slices/volumesAndWipSlice";

interface OwnProps {
    processPathDisplayName: string;
    processPathName: string;
    targetVolume: number;
    wipVolume?: number;
    readOnly?: boolean;
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
    const { processPathName, processPathDisplayName } = ownProps;
    const overrides = state.volumesAndWip.processPathOverrides;
    
    // Create a ProcessPathOverride object from the new format
    const processPathOverride: ProcessPathOverride = {};
    
    // Determine if this process path is primary or secondary by checking targetAndWIPVolume
    const isPrimary = state.volumesAndWip.targetAndWIPVolume?.primaryTargetAndWipVolume?.some(
        volume => volume.label === processPathName
    ) || false;
    
    // Get override value based on whether it's primary or secondary
    if (isPrimary) {
        // Check targetPrimaryVolumeDistribution for override value
        const primaryOverride = overrides.volumeContext.secondaryPathVolumeData.targetPrimaryVolumeDistribution
            .find(dist => dist.operationName === processPathName);
        if (primaryOverride) {
            processPathOverride.override = primaryOverride.volume;
            processPathOverride.overrideReason = primaryOverride.overrideReason;
            processPathOverride.overrideComment = primaryOverride.overrideComment;
        }
    } else {
        // Check targetSecondaryVolumeDistribution for override value (secondary path targets)
        const secondaryOverride = overrides.volumeContext.secondaryPathVolumeData.targetSecondaryVolumeDistribution
            .find(dist => dist.operationName === processPathName);
        if (secondaryOverride) {
            processPathOverride.override = secondaryOverride.volume;
            processPathOverride.overrideReason = secondaryOverride.overrideReason;
            processPathOverride.overrideComment = secondaryOverride.overrideComment;
        }
    }
    
    // Check wipSecondaryVolumeDistribution for wipOverride value (only secondary volumes have WIP)
    const wipOverride = overrides.volumeContext.secondaryPathVolumeData.wipSecondaryVolumeDistribution
        .find(dist => dist.operationName === processPathName);
    if (wipOverride) {
        processPathOverride.wipOverride = wipOverride.volume;
        processPathOverride.wipOverrideReason = wipOverride.overrideReason;
        processPathOverride.wipOverrideComment = wipOverride.overrideComment;
    }
    
    return { processPathOverride };
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    updateProcessPathOverride: (processPathName: string, field: 'override' | 'wipOverride' | 'overrideReason' | 'overrideComment' | 'wipOverrideReason' | 'wipOverrideComment', value: number | string | undefined) =>
        dispatch(updateProcessPathOverride({ processPathName, field, value }))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProcessPathVolumeRow);
